import React from "react";
import { Form, Input } from "antd";

const PriceOptionsForm = ({
  priceOptions,
  setPriceOptions,
  form,
  groupCurrency = "$",
}) => {

  return (
    <Form.Item label="Set Price/Entry Options">
      <div>
        <div style={{ display: "flex", width: "100%", marginBottom: "8px" }}>
          <p style={{ width: "50%", fontWeight: "bold" }}>Price</p>
          <p style={{ width: "50%", fontWeight: "bold" }}>Entries</p>
        </div>

        {priceOptions.map((option, index) => (
          <div
            key={index}
            style={{ marginBottom: "15px", alignItems: "center" }}
          >
            <div style={{ marginRight: "10px" }}>
              {option.required && <span style={{ color: "red" }}>*</span>}{" "}
              Option {index + 1}:
            </div>
            <div style={{ display: "flex" }}>
              <Form.Item noStyle name={["priceOptions", `price${index}`]}>
                <Input
                  maxLength={3}
                  placeholder="Price"
                  type="number"
                  min={1}
                  defaultValue={option.price}
                  value={option.price}
                  style={{ width: "100%", marginRight: "15px" }}
                  addonBefore={groupCurrency}
                  onChange={(e) => {
                    const newPriceOptions = [...priceOptions];
                    const newValue =
                      e.target.value === "" ? null : Number(e.target.value);
                    newPriceOptions[index].price = newValue;
                    setPriceOptions(newPriceOptions);

                    if (newValue !== null) {
                      form.setFields([
                        {
                          name: ["priceOptions", `price${index}`],
                          errors: [],
                        },
                      ]);
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Form.Item>
              <Form.Item noStyle name={["priceOptions", `entry${index}`]}>
                <Input
                  maxLength={3}
                  placeholder="Entries"
                  type="number"
                  min={1}
                  style={{ width: "100%" }}
                  value={option.entry}
                  defaultValue={option.entry}
                  onChange={(e) => {
                    const newPriceOptions = [...priceOptions];
                    const newValue =
                      e.target.value === "" ? null : Number(e.target.value);
                    newPriceOptions[index].entry = newValue;
                    setPriceOptions(newPriceOptions);

                    if (newValue !== null) {
                      form.setFields([
                        {
                          name: ["priceOptions", `entry${index}`],
                          errors: [],
                        },
                      ]);
                    }
                  }}
                  onWheel={(e) => e.target.blur()}
                />
              </Form.Item>
            </div>
          </div>
        ))}
      </div>
    </Form.Item>
  );
};

export default PriceOptionsForm;
